import { createSupabasePublicClient } from '@/lib/supabase/public';
import type {
  Faq,
  NewsPost,
  Service,
  SiteSettings,
  TeamMember,
} from '@/lib/supabase/types';

export async function getSettings(): Promise<SiteSettings | null> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('site_settings')
    .select('*')
    .eq('id', 1)
    .maybeSingle();
  return data as SiteSettings | null;
}

export async function listServices(): Promise<Service[]> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('services')
    .select('*')
    .eq('status', 'published')
    .order('order_index', { ascending: true });
  return (data ?? []) as Service[];
}

export async function getServiceBySlug(slug: string): Promise<Service | null> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('services')
    .select('*')
    .eq('slug', slug)
    .eq('status', 'published')
    .maybeSingle();
  return data as Service | null;
}

export async function listTeam(): Promise<TeamMember[]> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('team_members')
    .select('*')
    .eq('status', 'published')
    .order('order_index', { ascending: true });
  return (data ?? []) as TeamMember[];
}

export async function listNews(limit?: number): Promise<NewsPost[]> {
  const supabase = createSupabasePublicClient();
  let query = supabase
    .from('news_posts')
    .select('*')
    .eq('status', 'published')
    .order('published_at', { ascending: false });
  if (limit) query = query.limit(limit);
  const { data } = await query;
  return (data ?? []) as NewsPost[];
}

export async function getNewsBySlug(slug: string): Promise<NewsPost | null> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('news_posts')
    .select('*')
    .eq('slug', slug)
    .eq('status', 'published')
    .maybeSingle();
  return data as NewsPost | null;
}

export async function listFaqs(): Promise<Faq[]> {
  const supabase = createSupabasePublicClient();
  const { data } = await supabase
    .from('faqs')
    .select('*')
    .eq('status', 'published')
    .order('order_index', { ascending: true });
  return (data ?? []) as Faq[];
}
